import { unboundArtwork } from '../../data/unbound';

const labels = {
  greater: ['Greater manifestation', 'The Gathered Form'],
  lesser: ['Lesser manifestation', 'The Hunting Projection'],
};

export const UnboundArtwork = ({ version = 'lesser', prefix, priority = false }) => <figure className={`unbound-artwork unbound-artwork-${version}`} data-testid={`${prefix}-artwork`}>
  <img src={unboundArtwork[version]} alt={`${labels[version][0]} of the Unbound — ${labels[version][1]}`} width={version === 'greater' ? 1536 : 1024} height={version === 'greater' ? 1024 : 1536} loading={priority ? 'eager' : 'lazy'} fetchPriority={priority ? 'high' : 'auto'} data-testid={`${prefix}-image`} />
  <figcaption data-testid={`${prefix}-caption`}><span>{labels[version][0]}</span><strong>{labels[version][1]}</strong></figcaption>
</figure>;